export default {
  'transfers.approve.error': 'You are not eligible to approve some selected transfers.',
  'transfers.approve.message': 'Approving the following transfers',
  'transfers.date': 'Transfer Date',
  'transfers.delete.error': 'You are not eligible to delete some selected transfers.',
  'transfers.grid.approved': 'Approved',
  'transfers.grid.canceled': 'Canceled',
  'transfers.grid.deleted': 'Deleted',
  'transfers.grid.noappreq': 'No Approval Required',
  'transfers.grid.pending': 'Pending',
  'transfers.grid.rejected': 'Rejected',
  'transfers.grid.savedViews.allTransfers': 'All Transfers',
  'transfer.activity': 'Transfer Activity',
  'transfers.grid.savedViews.filter.containsApproval': 'Contains Requires My Approval',
  'TRANSFER.DATE_EARLY': 'Back dated processing date not allowed.',
  'transfers.grid.savedViews.noTransfersToApprove': 'No transfers to approve',
  'transfers.grid.savedViews.requiresMyApproval': 'Requires my Approval',
  'transfers.import': 'Import Transfer File',
  'transfers.imports': 'Transfers Imports',
  'transfers.initiate': 'Initiate Transfer',
  'transfers.recurring': 'Recurring Transfer',
  'transfers.reject.message': 'Rejecting the following transfers',
  'transfers.title': 'Initiate Transfer(s)',
  'transfers.titleSingle': 'Initiate Transfer',
  'transfers.workflow': 'Initiate Transfer(s)',

  'transfers.manageImportMaps.heading': 'Manage Transfer Map',
  'transfers.manageImportMaps.actionHeading': '<%-action %> Import Mapping',
  'transfers.manageImportMaps.create.success': 'Import map <%-mapName %> has been created.',
  'transfers.manageImportMaps.create.failed': 'Import map <%-mapName %> has failed to be created.',
  'transfers.manageImportMaps.modify.success': 'Import map <%-mapName %> has been modified.',
  'transfers.manageImportMaps.modify.failed':
    'Import map <%-mapName %> has failed to be modified.',
  'transfers.manageImportMaps.delete.succeeded': 'Import map <%-mapName %> has been deleted.',
  'transfers.manageImportMaps.delete.failed': 'Import map <%-mapName %> has failed to delete.',
  'transfers.manageImportMaps.delete.warning': 'Delete Import Map',
  'transfers.manageImportMaps.delete.content': 'Are you sure you want to delete <%=mapName %>?',
  'transfers.manageImportMaps.delete.confirm': 'This action cannot be undone',
  'transfers.manageImportMaps.lastUsedDate': 'Last Used Date',
  'transfers.manageImportMaps.lastUsedBy': 'Last Used By',
  'transfers.manageImportMaps.create.subtitle': 'Delimited File Map',
  'transfers.manageImportMaps.fieldName': 'Field Name',
  'transfers.manageImportMaps.fieldPosition': 'Field Position',
  'transfers.manageImportMaps.stripZeros': 'Strip Zeros',
  'transfers.manageImportMaps.validation.uniqueFieldPosition': 'Field position is not unique',
  'transfers.manageImportMaps.processingDate.message': 'Format date as MMDDYYYY',
  'transfers.manageImportMaps.sequenceNumber.message':
    'Sequence Number determines specific processing order',
  'transfers.manageImportMaps.skipFirstHeaderRecords': 'Skip First Header Record',
  'transfers.manageImportMaps.comma': 'Comma (,)',
  'transfers.manageImportMaps.asterisk': 'Asterisk (*)',
  'transfers.manageImportMaps.colon': 'Colon (:)',
  'transfers.manageImportMaps.semicolon': 'Semicolon (;)',
  'transfers.manageImportMaps.backslash': 'Backslash (\\)',
  'transfers.manageImportMaps.forwardslash': 'Forward Slash (/)',
  'transfers.manageImportMaps.pipe': 'Pipe (|)',
  'transfers.manageImportMaps.tab': 'Tab (↹)',
  'transfers.singleTransfer.removeAdditionalTransfer': 'remove additional transfer'
};
